export default __webpack_public_path__ + "static/media/sailfin-logo.dab55801.svg";